import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface NoProjectsMessageProps {
  canCreateProjects: boolean
  onClickCreateProject: () => void
}

const NoProjectsMessage = ({ canCreateProjects, onClickCreateProject }: NoProjectsMessageProps) => {
  return (
    <Box textAlign="center" gap="s8" maxWidth="s600" paddingX="s24">
      <Text weight="medium" size="400" color="grey1000">
        {i18n.t('project_management.table.projects_list.no_projects_message.title')}
      </Text>
      <Text weight="normal" size="300" color="grey800">
        {i18n.t('project_management.table.projects_list.no_projects_message.description')}
      </Text>
      {canCreateProjects && (
        <Box paddingTop="s12" flexDirection="row" justifyContent="center">
          <Button onClick={onClickCreateProject} iconName="add">
            {i18n.t('project_management.add_button')}
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default NoProjectsMessage
